import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import EditIcon from "@mui/icons-material/Edit";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import SearchIcon from "@mui/icons-material/Search";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  Box,
  Button,
  Chip,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import React, { useEffect, useState } from "react";
import KenLoader from "../../GlobalComponents/KenLoader";
import { useToast } from "../../Helpers/Contexts/toastContext";
import { useAuthStore } from "../../store";
import {
  getPlayersDetails,
  getTeamDetails,
  updatePlayerDetails,
} from "../../Utils/apiService";
import {
  calculateTeamStatus,
  formatToIndianCurrencyWords,
  getRoleType,
  mapHighestLevelToCategory,
  splitCurrencyValueAndUnit,
  validateTeamSelectionStatus,
} from "../../Utils/helperFunctions";
import BidPriceModal from "./components/BidPriceModal";
import ConfirmStartBidModal from "./components/ConfirmStartBidModal";
import InsufficiantFundModal from "./components/InsufficiantFundModal";


console.log("dummy commit")
const commonCellStyles = {
  color: "#fff",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  border: "none",
};

const TOTAL_PLAYER_LIMIT = 18;
const MIN_COUNTS = {
  "Icon Player": 1,
  "Senior Player": 4,
  "Emerging Player": 5,
  "Development Player": 5,
};

const MAX_COUNTS = {
  "Icon Player": 1,
  "Senior Player": 7,
  "Emerging Player": 8,
  "Development Player": 8,
};

const basePrices = {
  "Icon Player": 2000000,
  "Senior Player": 500000,
  "Emerging Player": 300000,
  "Development Player": 200000,
};

const MINIMUM_PURSE = 6500000; // 65 lakhs for minimum requirements
const RESERVE_FOR_EXTRAS = 600000; // 6 lakhs minimum reserve for 2 extra players
export const KITTY_ALLOCATION = 2900000; // 29 lakhs minimum reserve for 2 extra players

const Dashboard = () => {
  const { showToast } = useToast();
  const {
    triggerTeamDetailsUpdate,
    setSelectedPlayerData,
    clearLiveBidData,
    sendLiveTeamId,
  } = useAuthStore();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPlayer, setSelectedPlayer] = React.useState<any>(null);
  const [bidAmount, setBidAmount] = React.useState(200000);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedTeam, setSelectedTeam] = React.useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [playerDetails, setplayerDetails] = useState<any>();
  const [teamDetails, setTeamDetails] = useState<any>();
  const [trigger, setTrigger] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  } | null>(null);
  const [roleFilter, setRoleFilter] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);
  const [setFilter, setSetFilter] = useState<string | null>(null);
  const [appliedFilters, setAppliedFilters] = useState<{
    role?: string;
    status?: string;
    category?: string;
    set?: string;
  }>({});
  const [filterMenu, setFilterMenu] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [playerToEdit, setPlayerToEdit] = useState(null);
  const [insufficientFunds, setInsufficientFunds] = useState(false);
  const [uniqueSets, setUniqueSets] = useState(false);
  const [Kitty_Bid_Amount, setKittyBidAmount] = useState(0);
  // const [showTeamModal, setShowTeamModal] = React.useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);

      const [playersRes, teamsRes] = await Promise.all([
        getPlayersDetails(),
        getTeamDetails(),
      ]);

      if (playersRes?.data?.success) {
        const players = playersRes.data.data;
        setplayerDetails(players);

        const allSets = players
          .map((player: any) => player.set)
          .filter((set: any) => set);
        const uniqueSetList: any = [...new Set(allSets)];
        setUniqueSets(uniqueSetList);

        if (teamsRes?.data?.success) {
          const teams = teamsRes.data.data;
          const enrichedTeams = calculateTeamStatus(players, teams);
          setTeamDetails(teams);
        }
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [trigger]);

  const teamdetailsWithStatus = (bid: any, player: any) => {
    for (let i = 0; i < teamDetails?.length; i++) {
      const team = teamDetails[i];
      const teamStatus = validateTeamSelectionStatus(
        team,
        player,
        playerDetails,
        KITTY_ALLOCATION,
        MINIMUM_PURSE,
        RESERVE_FOR_EXTRAS,
        bid
      );
      setTeamDetails((prev: any) => {
        const updatedTeams = [...prev];
        updatedTeams[i] = {
          ...team,
          teamStatus: teamStatus,
        };
        return updatedTeams;
      });
      console.log(teamStatus, "teamStatus after rthe helper funcrtion");
    }
  };

  const handleUnsold = () => {
    const nameParts = selectedPlayer.name.trim().split(" ");
    const firstName = nameParts[0];
    const lastName = nameParts?.slice(1).join(" ");
    const basePrice = formatToIndianCurrencyWords(selectedPlayer.basePrice);
    const playerDataForLiveAuction = {
      firstName,
      lastName,
      photo: selectedPlayer.photo,
      MCANo: selectedPlayer.MCANo,
      playerAge: selectedPlayer.playerAge,
      playerBirthDate: selectedPlayer.birthData,
      roleType: getRoleType(selectedPlayer),
      highest_level_played: selectedPlayer.recentCompetetionLevel,
      auctionResult: "Unsold",
      basePrice: basePrice,
      teamLogo: selectedTeam?.Logo_URL__c,
      teamName: selectedTeam?.Name,
      playerDetails: selectedPlayer,
    };

    const updatePayload = {
      Auction_Result__c: "Unsold",
      Sold_To__c: null,
      Winning_Bid__c: null,
    };
    const recordId = selectedPlayer?.playerRegId;
    updatePlayerDetails(recordId, updatePayload)
      .then(async (res) => {
        await triggerTeamDetailsUpdate();
        await setSelectedPlayerData(playerDataForLiveAuction);
        await setTrigger(!trigger);
        setModalOpen(false);
      })
      .catch((err) => {
        showToast("error", "Error Updating Player registration");
      });
  };

  const handleEditClick = async (player: any) => {
    setPlayerToEdit(player);
    setConfirmModalOpen(true);
  };

  const handleConfirmStartBid = async () => {
    const player: any = playerToEdit;
    setConfirmModalOpen(false);

    const nameParts = player.name.trim().split(" ");
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(" ");
    const bidSplit = splitCurrencyValueAndUnit(bidAmount);
    const basePrice = formatToIndianCurrencyWords(player.basePrice);
    const playerDataForLiveAuction = {
      firstName,
      lastName,
      photo: player.photo,
      MCANo: player.MCANo,
      playerAge: player.playerAge,
      playerBirthDate: player?.birthData,
      role: player.role,
      roleType: getRoleType(player),
      highest_level_played: player.recentCompetetionLevel,
      auctionResult: "Stats",
      bidAmount: bidSplit.value,
      bidUnit: bidSplit.unit,
      basePrice: basePrice,
      teamLogo: selectedTeam?.Logo_URL__c,
      teamName: selectedTeam?.Name,
      playerDetails: player,
    };

    await triggerTeamDetailsUpdate();
    await setSelectedPlayerData(playerDataForLiveAuction);
    await teamdetailsWithStatus(player?.basePrice, playerDataForLiveAuction);
    setSelectedPlayer(player);
    setBidAmount(player.basePrice);
    setModalOpen(true);
  };

  const handleFinalize = () => {
    setModalOpen(false);
    // setShowTeamModal(true);
  };

  const handleTeamConfirm = async () => {
    if (!selectedTeam || !selectedPlayer) return;
    const nameParts = selectedPlayer.name.trim().split(" ");
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(" ");
    const bidSplit = splitCurrencyValueAndUnit(bidAmount);
    const basePrice = formatToIndianCurrencyWords(selectedPlayer.basePrice);

    const updatePayload = {
      Winning_Bid__c: bidAmount,
      Sold_To__c: selectedTeam?.Id,
      Kitty_Bid_Amount__c: Kitty_Bid_Amount,
      Reserve_Bid_Amount__c: bidAmount - Kitty_Bid_Amount,
      Auction_Result__c: "Sold",
    };
    const playerDataForLiveAuction = {
      firstName,
      lastName,
      photo: selectedPlayer.photo,
      MCANo: selectedPlayer.MCANo,
      playerAge: selectedPlayer.playerAge,
      playerBirthDate: selectedPlayer?.birthData,
      roleType: getRoleType(selectedPlayer),
      highest_level_played: selectedPlayer.recentCompetetionLevel,
      auctionResult: "Sold",
      bidAmount: bidSplit.value,
      bidUnit: bidSplit.unit,
      basePrice: basePrice,
      teamLogo: selectedTeam?.Logo_URL__c,
      teamName: selectedTeam?.Name,
      playerDetails: selectedPlayer,
    };

    const recordId = selectedPlayer?.playerRegId;
    updatePlayerDetails(recordId, updatePayload)
      .then(async (res) => {
        await triggerTeamDetailsUpdate();
        await setSelectedPlayerData(playerDataForLiveAuction);
        await clearLiveBidData();
        setTrigger(!trigger);
        setModalOpen(false);
        // setShowTeamModal(false);
        setSelectedTeam(null);
      })
      .catch((err) => {
        showToast("error", "Error Updating Player registration");
        console.log(err, "errropi");
      });
  };

  const handleFilterMenuToggle = () => {
    setFilterMenu((prev) => !prev);
  };

  const filteredPlayers = playerDetails?.filter(
    (player: any, index: number) => {
      const term = searchTerm?.toLowerCase();
      const matchesSearch =
        player?.name?.toLowerCase().includes(term) ||
        // player.MCANo?.toLowerCase().includes(term) ||
        player?.auctionNumber?.toString() === term;
      // mapHighestLevelToCategory(player.recentCompetetionLevel)
      //   ?.toLowerCase()
      //   .includes(term);

      const matchesRole =
        !appliedFilters.role || player.role === appliedFilters.role;
      const matchesStatus =
        !appliedFilters.status ||
        (appliedFilters.status === "Sold" && player.auctionResult === "Sold") ||
        (appliedFilters.status === "Unsold" &&
          player.auctionResult === "Unsold") ||
        (appliedFilters.status === "Pending" && !player.auctionResult);

      const matchesCategory =
        !appliedFilters.category ||
        mapHighestLevelToCategory(player.recentCompetetionLevel) ===
        appliedFilters.category;

      const matchesSet =
        !appliedFilters.set || player.set === appliedFilters.set;

      return (
        matchesSearch &&
        matchesRole &&
        matchesStatus &&
        matchesCategory &&
        matchesSet
      );
    }
  );

  const sortedPlayers = React.useMemo(() => {
    if (!sortConfig) return filteredPlayers;
    const sorted = [...filteredPlayers].sort((a, b) => {
      const valA = a[sortConfig.key]?.toLowerCase?.() || "";
      const valB = b[sortConfig.key]?.toLowerCase?.() || "";
      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [filteredPlayers, sortConfig]);

  const calculateCurrentCounts = (players: any[]) => {
    const categoryCounts = players.reduce((acc, player) => {
      const cat = mapHighestLevelToCategory(player?.recentCompetetionLevel);
      acc[cat] = (acc[cat] || 0) + 1;
      return acc;
    }, {});

    return {
      currentCounts: {
        "Icon Player": categoryCounts["Icon Player"] || 0,
        "Senior Player": categoryCounts["Senior Player"] || 0,
        "Emerging Player": categoryCounts["Emerging Player"] || 0,
        "Development Player": categoryCounts["Development Player"] || 0,
      },
      totalPlayers: players?.length,
    };
  };

  const validateTeamSelection = (team: any): boolean => {
    if (!selectedPlayer || !playerDetails) return false;
    setKittyBidAmount(0);
    const category = mapHighestLevelToCategory(
      selectedPlayer?.recentCompetetionLevel
    );
    // const playersOfTeam = playerDetails.filter(
    //   (p: any) => p.soldToId === team.Id && p.auctionResult === "Sold"
    // );
    const playersOfTeam = []
    let totalkittyamt = 0
    let baseAmount = 0
    let totalplayerCount = {
      "Icon Player": 0,
      "Senior Player": 0,
      "Emerging Player": 0,
      "Development Player": 0,
    };
    for (let i = 0; i < playerDetails.length; i++) {
      let p = playerDetails[i];
      if (p.soldToId === team.Id && p.auctionResult === "Sold") {
        playersOfTeam.push(p);
        totalkittyamt = totalkittyamt + (p.kittyBidAmount || 0)
        baseAmount = baseAmount + (p.reserveBidAmount || 0);
        let role = mapHighestLevelToCategory(
          p?.recentCompetetionLevel
        )
        if (totalplayerCount.hasOwnProperty(role as keyof typeof basePrices)) {
          totalplayerCount[role as keyof typeof basePrices] = totalplayerCount[role as keyof typeof basePrices] + 1
        }
      }
    }

    // Calculate current category counts and required minimums
    const { currentCounts, totalPlayers } =
      calculateCurrentCounts(playersOfTeam);
    // const remainingFund = team?.Fund_Remaining__c || 0;

    let balanceKitty = KITTY_ALLOCATION - totalkittyamt
    let balanceBase = (MINIMUM_PURSE + RESERVE_FOR_EXTRAS) - baseAmount

    if ((currentCounts[category as keyof typeof MIN_COUNTS] + 1) <= MIN_COUNTS[category as keyof typeof MIN_COUNTS]) {

      if (bidAmount <= basePrices[category as keyof typeof basePrices]) {
        return true
      } else {
        let extraKittyAmt = bidAmount - basePrices[category as keyof typeof basePrices];
        let balanceKittyCalc = balanceKitty - extraKittyAmt;
        if (balanceKittyCalc >= 0) {

          setKittyBidAmount(extraKittyAmt);
          return true
        } else {
          showToast(
            "error",
            `Exceeds kitty by ₹${(extraKittyAmt).toLocaleString("en-IN")}`
          );
          return false;
        }
      }
    } else if ((currentCounts[category as keyof typeof MIN_COUNTS] + 1) <= MAX_COUNTS[category as keyof typeof MAX_COUNTS] && (playersOfTeam.length + 1) <= 18 && (balanceKitty>0||bidAmount==(RESERVE_FOR_EXTRAS / 3))) {


      if (balanceKitty == 0) {
        if (bidAmount == basePrices[category as keyof typeof basePrices]) {
          return true;
        } else if (
          bidAmount >= basePrices[category as keyof typeof basePrices]
        ) {
          showToast("error", `Insufficient Funds`);
          return false;
        } else 
        return true
      } 
      else {
        if (balanceKitty > 0) {
          let extraPlayerDeltaBaseAmount = bidAmount - (RESERVE_FOR_EXTRAS / 3);//300000
          if (extraPlayerDeltaBaseAmount > balanceKitty) {
            showToast(
              "error",
              `Insufficient Funds`
            );
            return false;
          } else if (extraPlayerDeltaBaseAmount <= balanceKitty) {
             setKittyBidAmount(extraPlayerDeltaBaseAmount);//since no execess fund in base reserve utilize form kitty
            return true;
          }
         
        }
        return true;
      }

    } else {
      showToast(
        "error",
        `Player limit exceeded`
      );
      return false;
    }
  };


  return loading ? (
    <KenLoader />
  ) : (
    <Box bgcolor="" color="#fff">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "36px",
        }}
      >
        <Box sx={{ display: "flex", gap: "20px" }}>
          <Typography variant="h4">Player list t20 Mumbai - 2025</Typography>
          <Box display="flex" gap={1} flexWrap="wrap">
            {appliedFilters.role && (
              <Chip
                label={appliedFilters.role}
                onDelete={() =>
                  setAppliedFilters((prev) => ({ ...prev, role: undefined }))
                }
                deleteIcon={<CloseOutlinedIcon />}
                sx={{
                  backgroundColor: "#333",
                  color: "#fff",
                  border: "1px solid #8D8D8D",
                  "& .MuiChip-deleteIcon": {
                    marginLeft: "4px",
                    color: "#fff",
                  },
                  "&:hover": {
                    backgroundColor: "#2a2a2a",
                  },
                }}
              />
            )}
            {appliedFilters.status && (
              <Chip
                label={appliedFilters.status}
                onDelete={() =>
                  setAppliedFilters((prev) => ({ ...prev, status: undefined }))
                }
                deleteIcon={<CloseOutlinedIcon />}
                sx={{
                  backgroundColor: "#333",
                  color: "#fff",
                  border: "1px solid #8D8D8D",
                  "& .MuiChip-deleteIcon": {
                    marginLeft: "4px",
                    color: "#fff",
                  },
                  "&:hover": {
                    backgroundColor: "#2a2a2a",
                  },
                }}
              />
            )}
            {appliedFilters.category && (
              <Chip
                label={appliedFilters.category}
                onDelete={() =>
                  setAppliedFilters((prev) => ({
                    ...prev,
                    category: undefined,
                  }))
                }
                deleteIcon={<CloseOutlinedIcon />}
                sx={{
                  backgroundColor: "#333",
                  color: "#fff",
                  border: "1px solid #8D8D8D",
                  "& .MuiChip-deleteIcon": {
                    marginLeft: "4px",
                    color: "#fff",
                  },
                  "&:hover": {
                    backgroundColor: "#2a2a2a",
                  },
                }}
              />
            )}
            {appliedFilters.set && (
              <Chip
                label={appliedFilters.set}
                onDelete={() =>
                  setAppliedFilters((prev) => ({ ...prev, set: undefined }))
                }
                deleteIcon={<CloseOutlinedIcon />}
                sx={{
                  backgroundColor: "#333",
                  color: "#fff",
                  border: "1px solid #8D8D8D",
                  "& .MuiChip-deleteIcon": {
                    marginLeft: "4px",
                    color: "#fff",
                  },
                  "&:hover": {
                    backgroundColor: "#2a2a2a",
                  },
                }}
              />
            )}
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{
                border: "0.5px solid rgba(255, 255, 255, 0.20)",
                borderRadius: "12px 8px 8px 8px",
                background: " #161616",
                padding: "15px",
                display: "flex",
                gap: "4px",
                cursor: "pointer",
                alignItems: "center",
              }}
              onClick={handleFilterMenuToggle}
            >
              Filter <FilterAltOutlinedIcon fontSize="small" />
            </Box>
            {filterMenu && (
              <ClickAwayListener onClickAway={() => setFilterMenu(false)}>
                <Box
                  sx={{
                    background: "#111",
                    borderRadius: "12px",
                    padding: "20px",
                    width: 300,
                    zIndex: 10,
                    minHeight: "400px",
                    position: "absolute",
                    top: "60px",
                    right: "0",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography variant="h6" color="#fff" mb={2}>
                    Filters
                  </Typography>
                  <TextField
                    select
                    fullWidth
                    value={roleFilter || ""}
                    onChange={(e) => setRoleFilter(e.target.value)}
                    SelectProps={{ native: true }}
                    sx={{ mb: 2 }}
                  >
                    <option value="">Select role</option>
                    <option value="Batsman">Batsman</option>
                    <option value="Bowler">Bowler</option>
                    <option value="All - rounder">All - rounder</option>
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    value={statusFilter || ""}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    SelectProps={{ native: true }}
                    sx={{
                      mb: 2,
                      "& .MuiSelect-icon": {
                        color: "#fff",
                      },
                    }}
                  >
                    <option value="">Select status</option>
                    <option value="Sold">Sold</option>
                    <option value="Unsold">Unsold</option>
                    <option value="Pending">Pending</option>
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    value={categoryFilter || ""}
                    onChange={(e) => setCategoryFilter(e.target.value)}
                    SelectProps={{ native: true }}
                    sx={{
                      mb: 2,
                      "& .MuiSelect-icon": {
                        color: "#fff",
                      },
                    }}
                  >
                    <option value="">Select Category</option>
                    <option value="Icon Player">Icon Player</option>
                    <option value="Senior Player">Senior Player</option>
                    <option value="Emerging Player">Emerging Player</option>
                    <option value="Development Player">
                      Development Player
                    </option>
                  </TextField>

                  {/* <TextField
                    select
                    fullWidth
                    value={setFilter || ""}
                    onChange={(e) => setSetFilter(e.target.value)}
                    SelectProps={{ native: true }}
                    sx={{
                      mb: 2,
                      "& .MuiSelect-icon": {
                        color: "#fff",
                      },
                    }}
                  >
                    <option value="">Select Set</option>
                    {uniqueSets &&
                      Array.isArray(uniqueSets) &&
                      uniqueSets.map((set: string) => (
                        <option key={set} value={set}>
                          {set}
                        </option>
                      ))}
                  </TextField> */}
                  <TextField
                    select
                    fullWidth
                    value={setFilter || ""}
                    onChange={(e) => setSetFilter(e.target.value)}
                    SelectProps={{ native: true }}
                    sx={{
                      mb: 2,
                      "& .MuiSelect-icon": {
                        color: "#fff",
                      },
                    }}
                  >
                    <option value="">Select Set</option>
                    {Array.isArray(uniqueSets) &&
                      [...uniqueSets]
                        .sort((a, b) => {
                          const numA = parseInt(a.match(/\d+/)?.[0] || "0", 10);
                          const numB = parseInt(b.match(/\d+/)?.[0] || "0", 10);
                          return numA - numB;
                        })
                        .map((set: string) => (
                          <option key={set} value={set}>
                            {set}
                          </option>
                        ))}
                  </TextField>

                  <Box display="flex" gap={2} mt={"auto"}>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setRoleFilter(null);
                        setStatusFilter(null);
                        setCategoryFilter(null);
                        setSetFilter(null);
                        setAppliedFilters({});
                      }}
                      sx={{ color: "#fff", borderColor: "#fff", flex: 1 }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        setAppliedFilters({
                          ...(roleFilter && { role: roleFilter }),
                          ...(categoryFilter && {
                            category: categoryFilter,
                          }),
                          ...(statusFilter && { status: statusFilter }),
                          ...(setFilter && { set: setFilter }),
                        });
                        setFilterMenu(false);
                      }}
                      sx={{
                        bgcolor: "#fff",
                        color: "#000",
                        fontWeight: 600,
                        flex: 1,
                      }}
                    >
                      {/* {filteredPlayers.length} */}
                      Show results
                    </Button>
                  </Box>
                </Box>
              </ClickAwayListener>
            )}
          </Box>
          <TextField
            // label="Search"
            placeholder="Search"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "#94969C", fontSize: "20px" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              borderRadius: "12px",
              fontSize: "10px!important",
              fontWeight: "350!important",
              marginBottom: "0",
              width: "320px",

              color: "white",
              // border: "1px solid #222",
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "#fff",
                  color: "#fff",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#7F56D9",
                },
                "& input": {
                  color: "#fff",
                },
              },
            }}
          />
          <Box
            sx={{
              border: "0.5px solid rgba(255, 255, 255, 0.20)",
              borderRadius: "8px",
              background:
                "linear-gradient(90deg, #E07E27 -22.62%, #E93301 100%)",
              padding: "14px",
              display: "flex",
              gap: "4px",
              alignItems: "center",
              fontWeight: "500",
              cursor: "pointer",
            }}
            // onClick={() => useAuthStore.getState().clearSelectedPlayerData()}
            onClick={() => {
              if (
                window.confirm(
                  "Are you sure you want to clear the live auction queue?"
                )
              ) {
                useAuthStore.getState().clearSelectedPlayerData();
              }
            }}
          >
            Clear queue
          </Box>
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        sx={{ backgroundColor: "#1e1e1e", border: "1px solid #FFFFFF33" }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ borderBottom: "1px solid #FFFFFF33" }}>
              {[
                { label: "Auction No" },
                { label: "Name of the player", sortKey: "name" },
                { label: "MCA ID", sortKey: "MCANo" },
                { label: "Role" },
                // { label: "Runs" },
                // { label: "Matches" },
                // { label: "Wickets" },
                { label: "Base price" },
                { label: "Category" },
                { label: "set" },
                { label: "Sold for" },
                { label: "Status" },
                { label: "Sold to" },
                { label: "Bid price" },
              ].map(({ label, sortKey }, idx) => {
                const isActive = sortKey && sortConfig?.key === sortKey;
                const isSortable = Boolean(sortKey);
                const direction = isActive ? sortConfig?.direction : "asc";
                return (
                  <TableCell
                    key={idx}
                    sx={{
                      color: "#fff",
                      border: "none",
                      fontWeight: "600",
                      fontSize: "16px",
                      cursor: isSortable ? "pointer" : "default",
                      userSelect: "none",
                    }}
                    onClick={() => {
                      if (!sortKey) return;
                      setSortConfig((prev) =>
                        prev?.key === sortKey
                          ? {
                              key: sortKey,
                              direction:
                                prev.direction === "asc" ? "desc" : "asc",
                            }
                          : { key: sortKey, direction: "asc" }
                      );
                    }}
                  >
                    <Box display="flex" alignItems="center" gap="4px">
                      {label}
                      {isSortable && (
                        <span
                          style={{
                            fontSize: "14px",
                            opacity: isActive ? 1 : 0.5,
                          }}
                        >
                          {direction === "asc" ? (
                            <SwapVertIcon />
                          ) : (
                            <SwapVertIcon />
                          )}
                        </span>
                      )}
                    </Box>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedPlayers
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((player: any, index: number) => {
                const soldStatus =
                  player.auctionResult === "Sold"
                    ? {
                        label: "Sold",
                        background: "#7DC789",
                        color: "##212120",
                      }
                    : player.auctionResult === "Unsold"
                    ? {
                        label: "Unsold",
                        background: "#F8A6A6",
                        color: "#212120",
                      }
                    : null;

                return (
                  <TableRow
                    key={player.playerId}
                    sx={{ borderBottom: "1px solid #FFFFFF33" }}
                  >
                    <TableCell sx={commonCellStyles}>
                      {player?.auctionNumber ?? "--"}
                    </TableCell>
                    <TableCell sx={commonCellStyles}>{player.name}</TableCell>
                    <TableCell sx={commonCellStyles}>{player.MCANo}</TableCell>
                    <TableCell sx={commonCellStyles}>{player.role}</TableCell>
                    {/* <TableCell sx={commonCellStyles}>
                      {runs ?? "-"}
                    </TableCell>
                    <TableCell sx={commonCellStyles}>
                      {matches ?? "-"}
                    </TableCell>
                    <TableCell sx={commonCellStyles}>
                      {wickets ?? "-"}
                    </TableCell> */}
                    <TableCell sx={commonCellStyles}>
                      {player.basePrice != null
                        ? `₹${player.basePrice.toLocaleString("en-IN")}`
                        : "--"}
                    </TableCell>
                    <TableCell sx={commonCellStyles}>{player?.set}</TableCell>
                    <TableCell sx={commonCellStyles}>
                      {mapHighestLevelToCategory(
                        player?.recentCompetetionLevel
                      )}
                    </TableCell>

                    <TableCell sx={commonCellStyles}>
                      {player.winningBid != null
                        ? `₹${player.winningBid.toLocaleString("en-IN")}`
                        : "--"}
                    </TableCell>
                    <TableCell sx={commonCellStyles}>
                      {soldStatus ? (
                        <Chip
                          label={soldStatus.label}
                          sx={{
                            color: soldStatus.color,
                            background: soldStatus.background,
                            borderRadius: "8px",
                            height: "36px",
                            minWidth: "83px",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell
                      sx={commonCellStyles}
                      onClick={async () => {
                        await sendLiveTeamId(player?.soldToId);
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <Box
                          component={"img"}
                          sx={{ height: "25px" }}
                          src={
                            player?.soldTo === "MSC Maratha Royals"
                              ? "https://mcadirectory.blob.core.windows.net/dev/4441894866960012-shivajiParkLions.png"
                              : player?.soldToLogo
                          }
                          alt=""
                        />
                        {player?.soldTo || "--"}
                      </Box>
                    </TableCell>
                    <TableCell sx={commonCellStyles}>
                      {/* {!soldStatus && ( */}
                      <IconButton
                        color="primary"
                        onClick={() => handleEditClick(player)}
                        sx={{
                          background: "#454545",
                          borderRadius: "4px",
                          color: "white",
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                      {/* )} */}
                      {/* {soldStatus && "--"} */}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={filteredPlayers?.length}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        sx={{
          color: "#fff",
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              color: "#fff",
            },
          "& .MuiInputBase-root": {
            color: "#fff",
          },
          "& .MuiSvgIcon-root": {
            fill: "#fff",
          },
        }}
      />

      <ConfirmStartBidModal
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={handleConfirmStartBid}
        player={playerToEdit}
      />
      <BidPriceModal
        open={modalOpen}
        onClose={() => {
          useAuthStore.getState().clearSelectedPlayerData();
          useAuthStore.getState().clearLiveBidData();
          setModalOpen(false);
        }}
        player={selectedPlayer}
        bid={bidAmount}
        setBid={setBidAmount}
        onFinalize={handleFinalize}
        onUnsold={handleUnsold}
        teams={teamDetails}
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
        onConfirm={handleTeamConfirm}
        validateTeam={validateTeamSelection}
        teamdetailsWithStatus={teamdetailsWithStatus}
      />
      {/* <TeamSelectModal
        open={showTeamModal}
        // onClose={() => {
        //   setShowTeamModal(false);
        // }}
        bidPrice={bidAmount}
        teams={teamDetails}
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
        onConfirm={handleTeamConfirm}
        onGoBack={() => {
          setShowTeamModal(false);
          setModalOpen(true);
        }}
        validateTeam={validateTeamSelection}
      /> */}
      <InsufficiantFundModal
        open={insufficientFunds}
        onClose={() => setInsufficientFunds(false)}
      />
    </Box>
  );
};

export default Dashboard;
